var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{staticClass:"text-left form-control",class:['is-' + _vm.state],attrs:{"type":"text","id":_vm.id,"placeholder":this.placeholder,"mask":_vm.digitMask,"guide":false},on:{"change":_vm.callChange,"keyup":_vm.callKeyUp},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }